import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExpuestosPoliticamenteService {
  private baseUrl = `${environment.apiNest}expuestos-politicamente`;

  constructor(private http: HttpClient) {}

  // Sin `skip`: el interceptor adjunta el JWT de la sesión (el back exige estar
  // autenticado, y operador para leer/editar la tabla — A7 de la auditoría).
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  async create(payload: {
    tipoDoc: string;
    document: string;
    dataInfo?: any;
  }): Promise<any> {
    const url = this.baseUrl;
    try {
      const response = await firstValueFrom(
        this.http.post(url, payload, { headers: this.getHeaders() }),
      );
      return response;
    } catch (error: any) {
      throw this.formatError(error, 'crear expuesto');
    }
  }

  async findAll(): Promise<any> {
    const url = this.baseUrl;
    try {
      const response = await firstValueFrom(
        this.http.get(url, { headers: this.getHeaders() }),
      );
      return response;
    } catch (error: any) {
      throw this.formatError(error, 'obtener lista de expuestos');
    }
  }

  async findOne(id: string): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    try {
      const response = await firstValueFrom(
        this.http.get(url, { headers: this.getHeaders() }),
      );
      return response;
    } catch (error: any) {
      throw this.formatError(error, `obtener expuesto con id ${id}`);
    }
  }

  async update(
    id: string,
    data: Partial<{ tipoDoc: string; document: string; dataInfo?: any }>,
  ): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    try {
      const response = await firstValueFrom(
        this.http.patch(url, data, { headers: this.getHeaders() }),
      );
      return response;
    } catch (error: any) {
      throw this.formatError(error, `actualizar expuesto con id ${id}`);
    }
  }

  async remove(id: string): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    try {
      const response = await firstValueFrom(
        this.http.delete(url, { headers: this.getHeaders() }),
      );
      return response;
    } catch (error: any) {
      throw this.formatError(error, `eliminar expuesto con id ${id}`);
    }
  }

  private formatError(error: any, action: string) {
    return {
      message: `Error al ${action}`,
      detail: error?.error || error?.message || error,
      statusCode: error?.status || 500,
    };
  }
}
